module.exports = __webpack_public_path__ + "static/media/fig_29a.d65d9ec7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_29a.jpg
// module id = 668
// module chunks = 0